import './bootstrap';
import './jquery';
import './axios';
import './swiper';
import './typed';
import './accounting';
import './nouislider';
import './lozad';
import './leaflet';
import './wnumb';
import './aos';
import './plyr';
import './tom-select';
import './utm';
import "./screensaver";

if (import.meta.env.PROD) {
    import('./ekonsilio').then(({ initEkonsilioChat, onUserInteract, observerUserChat }) => {
        observerUserChat();
    });
}
// if (import.meta.env.PROD) {
    // // compila solo in production
    // import("./lenis");
// }
import './import-custom-modules';
import './myscripts'; // myscripts sempre alla fine

